const GTM_SCRIPT_ID = 'gtm-script';
const GTM_NOSCRIPT_ID = 'gtm-noscript';

export function initGTM(gtmId) {
    if (!gtmId || document.getElementById(GTM_SCRIPT_ID)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'gtm.start': Date.now(),
        event: 'gtm.js',
    });

    const script = document.createElement('script');
    script.id = GTM_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

    const firstScript = document.getElementsByTagName('script')[0];

    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }

    if (document.body && !document.getElementById(GTM_NOSCRIPT_ID)) {
        const noscript = document.createElement('noscript');
        noscript.id = GTM_NOSCRIPT_ID;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';

        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
    }
}